import React from 'react';
import { ModelViewerProvider } from '@aibuild/model-viewer';
import { trackError } from '@utils/datadog';
import { useViewRenderCapability } from './useViewRenderCapability';

/** The 3D viewer's wiring in the OS app: failures to Datadog, AI renders for a signed-in user. */
const AppModelViewerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const viewRender = useViewRenderCapability();
  return (
    <ModelViewerProvider onError={trackError} viewRender={viewRender}>
      {children}
    </ModelViewerProvider>
  );
};

export default AppModelViewerProvider;
